import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
    getAttemptScore, 
    addAttemptScore as postAttemptScore, 
    updateAttemptScore as putAttemptScore, 
    deleteAttemptScore as removeAttemptScore,
    activateDeactivateAttemptScore as activateAttemptScore
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchAttemptScoreTableColumnNames = createAsyncThunk("attemptScore/fetchTableColumnNames", async (attemptScore, thunkAPI) => {
    try {
      const response = await getHeaders(attemptScore); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Attempt Score
export const fetchAllAttemptScore = createAsyncThunk("attemptScore/fetchAll", async (thunkAPI) => {
    try {
      const response = await getAttemptScore(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Attempt Score
export const createAttemptScore = createAsyncThunk("attemptScore/add", async (attemptScore, thunkAPI) => {  
    try {
        const response = await postAttemptScore(attemptScore);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Attempt Score
export const updateAttemptScore = createAsyncThunk("attemptScore/update", async (attemptScore, thunkAPI) => {
    try {
        const response = await putAttemptScore(attemptScore);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Attempt Score
export const deleteAttemptScore = createAsyncThunk("attemptScore/delete", async (attemptScore, thunkAPI) => {
    try {
        const response = await removeAttemptScore(attemptScore);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Activate Deactivate Attempt Score
export const activateDeactivateAttemptScore = createAsyncThunk("attemptScore/activateDeactivate", async (attemptScore, thunkAPI) => {
  try {
    const response = await activateAttemptScore(attemptScore);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});